import { initializeApp } from "firebase/app"
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signOut,
  FacebookAuthProvider,
  signInWithEmailAndPassword,
} from "firebase/auth"

const firebaseConfig = {
  apiKey: "AIzaSyCAjp5ByJ7x5r-8tprKOA9KDlWo_PhhegY",
  authDomain: "bestever-stage.firebaseapp.com",
  projectId: "bestever-stage",
  storageBucket: "bestever-stage.appspot.com",
  messagingSenderId: "6514965028",
  appId: "1:6514965028:web:28a52235e30691f8f3b6b1",
}

const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()
const facebookProvider = new FacebookAuthProvider()

const PROVIDERS = {
  google: googleProvider,
  facebook: facebookProvider,
}

const signInWithFirebase = async (
  provider: "google" | "facebook" | "emailpass",
  payload?: { email: string; password: string }
) => {
  try {
    let res = null
    if (provider === "emailpass") {
      res = await signInWithEmailAndPassword(
        auth,
        payload?.email as string,
        payload?.password as string
      )
    } else {
      res = await signInWithPopup(auth, PROVIDERS[provider])
    }
    const user = res.user
    return { user }
  } catch (error: any) {
    const errorCode = error.code
    const errorMessage = error.message
    console.info(errorCode, errorMessage)
    return { error: errorMessage }
  }
}

const logout = async (routeTo = "/") => {
  localStorage.removeItem("uuid")
  localStorage.removeItem("firebase_id")
  localStorage.removeItem("organization_id")
  await signOut(auth)
  window.location = routeTo as any
}

export { auth, signInWithFirebase, logout }
